module.exports = __webpack_public_path__ + "img/005.8548bae0.jpg";